import { z } from "zod"

const priceSchema = z
  .number()
  .nonnegative()
  .optional()
  .refine(value => {
    const decimals = value?.toString().split(".")[1] || ""
    return decimals.length <= 4
  }, "Maximum 4 decimal places allowed")

export const pricePanelSchema = z
  .object({
    currency: z.string(),
    min: priceSchema,
    max: priceSchema,
    rangeMin: z.float64().optional(),
  })
  .transform((data, ctx) => {
    const { rangeMin } = data
    if (rangeMin === undefined) {
      return data
    }

    const transformed = {
      ...data,
      min: data.min ?? rangeMin,
    }

    if (transformed.min < rangeMin) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Min must be atleast ${rangeMin.toString()}`,
        path: ["min"],
      })
      return z.NEVER
    }

    return transformed
  })
  .refine(
    data => {
      return (
        data.min === undefined || data.max === undefined || data.min < data.max
      )
    },
    {
      message: "Min price must be less than max price",
      path: ["min"],
    },
  )
  .refine(
    data => {
      return (
        data.min === undefined || data.max === undefined || data.min < data.max
      )
    },
    {
      message: "Min price must be less than max price",
      path: ["max"],
    },
  )
  .refine(data => {
    return data.min !== undefined || data.max !== undefined
  })

export type PricePanelFormValues = Omit<
  z.infer<typeof pricePanelSchema>,
  "min" | "max"
> & {
  min?: number
  max?: number
}
